import { SummarizableClassRegistration } from '@adaptiva/core/summary';
import { InstallableSoftware, MetadataObject, SoftwareIcon, SoftwarePatch, SoftwareProduct, SoftwareRelease, SoftwareReleaseGroup, StandaloneMetadataAuthoringRule } from '@adaptiva/metadata/common';
import { CloudRelayServer, Customer, CustomerServer } from '@adaptiva/operations-manager/common';

export const HOSTING_SUMMARIZABLE_CLASSES: SummarizableClassRegistration[] = [
	[CloudRelayServer.className, CloudRelayServer],
	[Customer.className, Customer],
	[CustomerServer.className, CustomerServer],
	[InstallableSoftware.className, InstallableSoftware],
	[MetadataObject.className, MetadataObject],
	[SoftwarePatch.className, SoftwarePatch],
	[SoftwareProduct.className, SoftwareProduct],
	[SoftwareRelease.className, SoftwareRelease],
	[SoftwareReleaseGroup.className, SoftwareReleaseGroup],
	[SoftwareIcon.className, SoftwareIcon],
	[StandaloneMetadataAuthoringRule.className, StandaloneMetadataAuthoringRule],
];

